import { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { supabase } from '@/lib/supabase';

export default function FloatingChatButton() {
  const navigate = useNavigate();
  const location = useLocation();
  const [authed, setAuthed] = useState(false);
  const [showTip, setShowTip] = useState(false);

  const isChatPage = location.pathname === '/live-chat' || location.pathname === '/chat-ho-tro';

  useEffect(() => {
    supabase.auth.getSession().then(({ data }) => {
      setAuthed(!!data.session);
    });

    const { data: listener } = supabase.auth.onAuthStateChange((_event, session) => {
      setAuthed(!!session);
    });

    return () => {
      listener.subscription.unsubscribe();
    };
  }, []);

  const handleClick = () => {
    if (authed) {
      navigate('/live-chat');
    } else {
      navigate('/dang-nhap?next=%2Flive-chat');
    }
  };

  return (
    <div className={`fixed bottom-6 right-6 z-50 flex items-center gap-3 ${isChatPage ? 'hidden' : ''}`}>
      {showTip && (
        <div className="hidden sm:block bg-foreground-950 text-background-50 text-sm font-medium px-4 py-2.5 rounded-lg whitespace-nowrap shadow-lg">
          {authed ? 'Cần hỗ trợ? Chat ngay!' : 'Đăng nhập để chat hỗ trợ'}
          <span className="absolute -right-1 top-1/2 -translate-y-1/2 w-2 h-2 bg-foreground-950 rotate-45"></span>
        </div>
      )}

      <button
        type="button"
        onClick={handleClick}
        onMouseEnter={() => setShowTip(true)}
        onMouseLeave={() => setShowTip(false)}
        aria-label="Mở chat hỗ trợ"
        className="relative w-14 h-14 rounded-full bg-primary-500 text-background-950 flex items-center justify-center cursor-pointer hover:bg-primary-600 hover:scale-105 active:scale-95 transition-all duration-200"
      >
        <span className="absolute inset-0 rounded-full bg-primary-500 opacity-40 animate-ping"></span>
        <i className="ri-chat-3-fill text-2xl relative"></i>
        <span className="absolute -top-0.5 -right-0.5 w-4 h-4 rounded-full bg-emerald-500 border-2 border-background-50"></span>
      </button>
    </div>
  );
}